var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_group"},[_c('div',{staticClass:"page_content"},[_c('el-pagination',{attrs:{"background":"","layout":_vm.layout||'prev, pager, next, jumper',"total":_vm.total,"page-size":_vm.pageSize|| 10,"current-page":_vm.currentPage === undefined ? 1 : _vm.currentPage},on:{"current-change":_vm.handleCurrentChange}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }